import _hasOwnProperty from "../internals/has-own-property";
import _isCallable from "../internals/is-callable";
import _toObject from "../internals/to-object";
import _sharedKey from "../internals/shared-key";
import _correctPrototypeGetter from "../internals/correct-prototype-getter";
var exports = {};
var hasOwn = _hasOwnProperty;
var isCallable = _isCallable;
var toObject = _toObject;
var sharedKey = _sharedKey;
var CORRECT_PROTOTYPE_GETTER = _correctPrototypeGetter;
var IE_PROTO = sharedKey("IE_PROTO");
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object ? ObjectPrototype : null;
};
export default exports;